import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Helmet } from 'react-helmet-async';
export function PrivacyPage() {
  return <>
      <Helmet data-id="element-286" data-mp="2s0l3y1ba5u6m">
        <title data-id="element-287" data-mp="2s01l8idt31rj">Privacy Policy - Fifth Door</title>
        <meta name="description" content="Fifth Door Privacy Policy." data-id="element-288" data-mp="2s3fnlqmgzayz" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-289" data-mp="2x1qxu2gofnhq" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-290" data-mp="32027od6z1xzy" />
        <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Bricolage+Grotesque:wght@400;500;600;700&family=Instrument+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-291" data-mp="36wsoj2qloxmf" />
      </Helmet>

      <main className="w-full relative isolate overflow-x-hidden min-h-screen" style={{
      backgroundColor: '#074030'
    }} data-id="element-292" data-mp="3kps392ik6nsx">
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '30px 30px',
        backgroundPosition: '0 0'
      }} data-id="element-293" data-mp="3ppcz342fmg1f" />
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px',
        opacity: 0.24
      }} data-id="element-294" data-mp="2ksovcqyae56b" />

        <div className="absolute top-8 left-8 z-20" data-id="element-295" data-mp="33oouqmtlgazx">
          <Link to="/" className="flex items-center gap-3" data-id="element-296" data-mp="4zhodmo7mxu6">
            <img src="https://cdn.magicpatterns.com/uploads/8dB8M4GqHB66FgPhzt2tyW/Group_44.png" alt="Fifth Door Logo" className="h-8 w-auto object-contain brightness-0 invert" data-id="element-297" data-mp="50spfeq9trhl" />
            <span className="text-white text-lg" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-298" data-mp="o436kbs10n5a">
              FIFTH DOOR
            </span>
          </Link>
        </div>

        <div className="relative z-10 px-6 py-20 md:py-32 max-w-4xl mx-auto" data-id="element-299" data-mp="ed8aygsw4b76">
          <h1 className="text-[50px] md:text-[74px] mb-8 text-center" style={{
          fontFamily: 'Bungee, sans-serif',
          color: 'white',
          lineHeight: '1.1'
        }} data-id="element-300" data-mp="dz4w9yeexgx">
            PRIVACY POLICY
          </h1>
          <div className="text-white/70 leading-relaxed text-lg space-y-6" style={{
          fontFamily: "'Instrument Sans', sans-serif"
        }} data-id="element-301" data-mp="3rkjrnhhf7j85">
            <p className="font-bold" data-id="element-302" data-mp="1ptgcqg0hzihs">Last Updated: April 13, 2026</p>

            <p data-id="element-303" data-mp="1psne62bozzaq">
              This Privacy Notice applies to the processing of personal
              information by Fifth Door, Inc. ("Fifth Door," "we," "us," or
              "our") including on our website available at
              https://fifthdoor.com/, our mobile application, and our other
              online or offline offerings that link to, or are otherwise subject
              to, this Privacy Notice (collectively, the "Services").
            </p>

            <div className="border border-white/10 rounded-xl p-6 bg-white/5 space-y-1" data-id="element-304" data-mp="3tyf8q09sm25p">
              <p className="font-bold text-white mb-2" data-id="element-305" data-mp="3p16l3k5vl5x2">Table of Contents</p>
              <a href="#section-1" className="block text-white/70 hover:text-white transition-colors" data-id="element-306" data-mp="6uigrwingmsg">
                1. Updates to This Privacy Notice
              </a>
              <a href="#section-2" className="block text-white/70 hover:text-white transition-colors" data-id="element-307" data-mp="28lc3r4uyw6ah">
                2. Personal Information We Collect
              </a>
              <a href="#section-3" className="block text-white/70 hover:text-white transition-colors" data-id="element-308" data-mp="260xkkymrcyfk">
                3. How We Use Personal Information
              </a>
              <a href="#section-4" className="block text-white/70 hover:text-white transition-colors" data-id="element-309" data-mp="2f36ubma7cnrw">
                4. How We Share Personal Information
              </a>
              <a href="#section-5" className="block text-white/70 hover:text-white transition-colors" data-id="element-310" data-mp="1mbvl9micg0xe">
                5. Your Privacy Choices and Rights
              </a>
              <a href="#section-6" className="block text-white/70 hover:text-white transition-colors" data-id="element-311" data-mp="212cmb4r2gotr">
                6. International Transfers of Personal Information
              </a>
              <a href="#section-7" className="block text-white/70 hover:text-white transition-colors" data-id="element-312" data-mp="18l0k6we36o4d">
                7. Retention of Personal Information
              </a>
              <a href="#section-8" className="block text-white/70 hover:text-white transition-colors" data-id="element-313" data-mp="w4hautkkevd8">
                8. Supplemental Notice for EU/UK GDPR
              </a>
              <a href="#section-9" className="block text-white/70 hover:text-white transition-colors" data-id="element-314" data-mp="m7w3w2ozja6r">
                9. Children's Personal Information
              </a>
              <a href="#section-10" className="block text-white/70 hover:text-white transition-colors" data-id="element-315" data-mp="8dvdpxc3mvi0">
                10. Contact Us
              </a>
            </div>

            <h2 id="section-1" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-316" data-mp="3ullb1k2neug5">
              1. UPDATES TO THIS PRIVACY NOTICE
            </h2>

            <p data-id="element-317" data-mp="3kxhe3ob4fd1d">
              We may update this Privacy Notice from time to time in our sole
              discretion. If we do, we'll let you know by posting the updated
              Privacy Notice on our website, and we may also send other
              communications.
            </p>

            <h2 id="section-2" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-318" data-mp="3h7tpyw4wsex">
              2. PERSONAL INFORMATION WE COLLECT
            </h2>

            <p data-id="element-319" data-mp="3pupvhmog3d1k">
              We collect personal information that you provide to us, personal
              information we collect automatically when you use the Services,
              and personal information from third-party sources, as described
              below.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-320" data-mp="r84xuphoulfm">
              Personal Information You Provide to Us Directly
            </h3>

            <p data-id="element-321" data-mp="wkaeki894krx">We may collect personal information that you provide to us.</p>

            <p data-id="element-322" data-mp="wi7knn3za7hx">
              <strong data-id="element-323" data-mp="1ab5nfuir31vi">Account Information.</strong> We may collect personal
              information in connection with the creation or administration of
              your account. This personal information may include, but is not
              limited to, your name, profile photo, username, email address, and
              other information you store with your account.
            </p>

            <p data-id="element-324" data-mp="rkxq5t1qf5n8">
              <strong data-id="element-325" data-mp="rlgxkftrabn0">Purchases or Transactions.</strong> We and our service
              providers may collect personal information and details associated
              with your purchases or transactions on the Services, including
              payment information. Any payments made via our Services are
              processed by third-party payment processors. We do not directly
              collect or store any payment card information entered through our
              Services, but we may receive information associated with your
              payment card information (e.g., your billing details).
            </p>

            <p data-id="element-326" data-mp="5bqn54cj1p1l">
              <strong data-id="element-327" data-mp="5b7fqhki6j1t">Your Communications with Us.</strong> We, and our service
              providers, may collect the information you communicate to us, such
              as through email.
            </p>

            <p data-id="element-328" data-mp="f21z9e6d74jk">
              <strong data-id="element-329" data-mp="f4o6tdt99k1s">Surveys.</strong> We may contact you to participate in
              surveys. If you decide to participate, we may collect personal
              information from you in connection with the surveys.
            </p>

            <p data-id="element-330" data-mp="t2cwcyy9pfd6">
              <strong data-id="element-331" data-mp="t0tej3wyqw9a">Interactive Features.</strong> We and others who use our
              Services may collect personal information that you submit or make
              available through our interactive features (e.g., messaging
              features, Discord, Feedback feature, commenting functionalities,
              forums, blogs, and social media pages). Any information you
              provide using the public sharing features of the Services will be
              considered "public."
            </p>

            <p data-id="element-332" data-mp="2dkotsqkf8day">
              <strong data-id="element-333" data-mp="2di2m8qxj5xsq">Friends' Information.</strong> When you use the "Friends"
              feature on the Services, we collect information about your friend
              connections, including incoming and outgoing friend requests, your
              friends' list, and any referral codes or links you generate or
              use. When you generate a referral code to share with others, the
              code is associated with your account. If another user enters your
              referral code or clicks on a referral link, your username and any
              public profile information you have chosen to share may be
              disclosed to that user. Similarly, when you enter another user's
              referral code, their username and public profile information may
              be disclosed to you.
            </p>

            <p data-id="element-334" data-mp="3kcx7wnwvb7ag">
              <strong data-id="element-335" data-mp="3kdf1fcs5b7eo">User Content.</strong> We may collect personal information
              that you provide when you generate, store or share mini-games and
              other content such as text (in posts or communications with
              others), files, documents, graphics, images, music, software,
              audio and video. Anything (other than Feedback) that you post or
              otherwise make available through the Services is referred to as
              "User Content". When you publish a game on the Services, other
              users may view your username and interact with your game content.
              If you generate a game, you do not receive any personal
              information about users who play such games, other than publicly
              displayed usernames and game statistics.
            </p>

            <p data-id="element-336" data-mp="2hrmx3q8ul2oj">
              <strong data-id="element-337" data-mp="x7ht0jc2zkir">Sweepstakes or Contests.</strong> We may collect personal
              information you provide for any sweepstakes or contests that we
              offer. In some jurisdictions, we are required to publicly share
              information of sweepstakes and contest winners.
            </p>

            <p data-id="element-338" data-mp="sg9krqmhm576">
              <strong data-id="element-339" data-mp="sfzx49ox0a4n">Conferences, Trade Shows, and Other Events.</strong> We
              may collect personal information from individuals when we attend
              or host conferences, trade shows, and other events.
            </p>

            <p data-id="element-340" data-mp="jhebu6s26h06">
              <strong data-id="element-341" data-mp="jdqm7ipqieqq">Business Development and Strategic Partnerships.</strong>{' '}
              We may collect personal information from individuals and third
              parties to assess and pursue potential business opportunities.
            </p>

            <p data-id="element-342" data-mp="1zvo3b9rlklv8">
              <strong data-id="element-343" data-mp="1zuuwk8sn1wd3">Job Applications.</strong> If you apply for a job with us,
              we will collect any personal information you provide in connection
              with your application, such as your contact information and resume
              or CV.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-344" data-mp="37sqxgii2qhf1">
              Personal Information Collected Automatically
            </h3>

            <p data-id="element-345" data-mp="33u1k2px1czve">
              We may collect personal information automatically when you use the
              Services.
            </p>

            <p data-id="element-346" data-mp="3vjwbqt8d91n8">
              <strong data-id="element-347" data-mp="3vibegvuo34lo">Device Information.</strong> We may collect personal
              information about your device, such as type of model and make of
              your device, your Internet protocol (IP) address, user settings,
              cookie identifiers, other unique identifiers, browser or device
              information, Internet service provider, and location information
              (including, as applicable, an approximate location derived from
              the IP address and precise geo-location information).
            </p>

            <p data-id="element-348" data-mp="e9eqcpcdgahw">
              <strong data-id="element-349" data-mp="lmnnh41up8e4">Usage Information.</strong> We may collect personal
              information about your use of the Services, such as the pages that
              you visit, number of users that can play, items that you search
              for, the types of content you interact with, information about the
              links you click, the frequency and duration of your activities,
              and other information about how you use the Services.
            </p>

            <p data-id="element-350" data-mp="14jfdrxft8nro">
              <strong data-id="element-351" data-mp="19k34ei04n2ld">Cookie Notice (and Other Technologies).</strong> We, as
              well as third parties, may use cookies, pixel tags, and other
              technologies ("Technologies") to automatically collect personal
              information through your use of the Services.
            </p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-352" data-mp="1nc12zyw7pg3a">
              <li data-id="element-353" data-mp="1ndkllw5cc388">
                <strong data-id="element-354" data-mp="1n9wt90bmtmv3">Cookies.</strong> Cookies are small text files stored in
                device browsers.
              </li>
              <li data-id="element-355" data-mp="1enlvj81dnb8d">
                <strong data-id="element-356" data-mp="1en2c1mw2wes8">Pixel Tags/Web Beacons.</strong> A pixel tag (also known
                as a web beacon) is a piece of code embedded in the Services
                that collects personal information about use of or engagement
                with the Services. The use of a pixel tag allows us to record,
                for example, that a user has visited a particular web page or
                clicked on a particular advertisement. We may also include web
                beacons in emails to understand whether messages have been
                opened, acted on, or forwarded.
              </li>
            </ul>

            <p data-id="element-357" data-mp="15oqjhfbnj6x5">
              See "Your Privacy Choices and Rights" below to understand your
              choices regarding these Technologies.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-358" data-mp="2h1jc0sc9nze9">
              Personal Information Collected from Third Parties
            </h3>

            <p data-id="element-359" data-mp="2c5lxmrkkd344">
              We may collect personal information about you from third parties.
              For example, if you access the Services using a third-party
              website, application, service, products, or technology (each a
              "Third-Party Service"), we may collect personal information about
              you from that Third-Party Service that you have made available via
              your privacy settings. In addition, users of the Services may
              upload or otherwise provide personal information about others.
              Please note that if you choose to make your profile public, other
              Fifth Door users will be able to view your profile information.
              You may choose to keep your profile private through your account
              settings.
            </p>

            <h2 id="section-3" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-360" data-mp="10i21dwli065g">
              3. HOW WE USE PERSONAL INFORMATION
            </h2>

            <p data-id="element-361" data-mp="1a67iu94a1ror">
              We use personal information for a variety of business purposes,
              including to provide the Services, for administrative purposes,
              and to provide you with marketing materials, as described below.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-362" data-mp="107ruuf0jqyjh">
              Provide the Services
            </h3>

            <p data-id="element-363" data-mp="w8995h0wijfl">We use personal information to provide the Services, such as:</p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-364" data-mp="reeskmglekkq">
              <li data-id="element-365" data-mp="mftqehhs5qtn">
                Providing access to certain areas, functionalities, and features
                of the Services;
              </li>
              <li data-id="element-366" data-mp="hffhkx8cucuk">Communicating with you;</li>
              <li data-id="element-367" data-mp="cip1i9wjvh95">Answering requests;</li>
              <li data-id="element-368" data-mp="chnnpxo5ggnq">
                Sharing personal information with third parties as needed to
                provide the Services; and
              </li>
              <li data-id="element-369" data-mp="2k4ywmtfhez8l">
                Processing your financial information and other payment methods.
              </li>
            </ul>

            <p className="text-sm italic" data-id="element-370" data-mp="2o47rk1m9d35q">
              EU/UK GDPR Lawful Bases: If the EU GDPR or the UK GDPR applies to
              our processing of personal information under this section, our
              lawful bases may include performance of a contract, legitimate
              interest, consent, and/or compliance with legal obligations.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-371" data-mp="25ej6r1c4f343">
              Improve the Services and Develop New Products and Services
            </h3>

            <p data-id="element-372" data-mp="2ackq7ndgl4g3">
              We use personal information to improve the Services and to develop
              new products and services, such as:
            </p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-373" data-mp="1hox7yeznupwm">
              <li data-id="element-374" data-mp="1mojqn3y9cyct">
                Developing, training, and fine-tuning models, algorithms, and
                artificial intelligence technologies; and
              </li>
              <li data-id="element-375" data-mp="g3bxk2m9luvu">Improving, upgrading, or enhancing the Services.</li>
            </ul>

            <p className="text-sm italic" data-id="element-376" data-mp="b48toli0tupg">
              EU/UK GDPR Lawful Bases: If the EU GDPR or the UK GDPR applies to
              our processing of personal information under this section, our
              lawful bases may include performance of a contract, legitimate
              interest, consent, and/or compliance with legal obligations.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-377" data-mp="u075frqs5gab">
              Operate Our Business
            </h3>

            <p data-id="element-378" data-mp="17s5czy4uf44d">We use personal information to operate our business, such as:</p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-379" data-mp="13s4o1jk4baj2">
              <li data-id="element-380" data-mp="1hqujkurah25b">
                Pursuing our legitimate interests such as direct marketing,
                research and development (including marketing research), network
                and information security, and fraud prevention;
              </li>
              <li data-id="element-381" data-mp="1we2x4282ljkg">Carrying out analytics;</li>
              <li data-id="element-382" data-mp="21ccv0kl6iy9r">Creating de-identified and/or aggregated information;</li>
              <li data-id="element-383" data-mp="21ajvdp8zheb9">
                Processing applications if you apply for a job we post on our
                Services;
              </li>
              <li data-id="element-384" data-mp="1rdnnnlqwsw7r">Allowing you to register for events;</li>
              <li data-id="element-385" data-mp="1rg9ufj5z77ox">Enforcing our agreements and policies; and</li>
              <li data-id="element-386" data-mp="1dma78goasegy">
                Carrying out activities that are required to comply with our
                legal obligations.
              </li>
            </ul>

            <p className="text-sm italic" data-id="element-387" data-mp="13pe5ctswmqld">
              EU/UK GDPR Lawful Bases: If the EU GDPR or the UK GDPR applies to
              our processing of personal information under this section, our
              lawful bases may include performance of a contract, legitimate
              interest, consent, and/or compliance with legal obligations.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-388" data-mp="yrm253mt7i1v">Marketing</h3>

            <p data-id="element-389" data-mp="3l0v14p8u4nhs">
              We may use personal information in connection with our marketing
              activities including to tailor and provide you with marketing
              communications, promotions, and offers that may interest you.
            </p>

            <p className="text-sm italic" data-id="element-390" data-mp="3g2bhwwlmlpt4">
              EU/UK GDPR Lawful Bases: If the EU GDPR or the UK GDPR applies to
              our processing of personal information under this section, our
              lawful bases may include legitimate interest and/or consent.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-391" data-mp="3v15gogice704">
              With Your Consent or Direction
            </h3>

            <p data-id="element-392" data-mp="2v8jk3bzmfaq">
              We may use personal information: (i) for other purposes that are
              clearly disclosed to you at the time you provide the personal
              information, (ii) with your consent, or (iii) as otherwise
              directed by you.
            </p>

            <p className="text-sm italic" data-id="element-393" data-mp="2g1yiikofurot">
              EU/UK GDPR Lawful Bases: If the EU GDPR or the UK GDPR applies to
              our processing of personal information under this section, our
              lawful bases may include performance of a contract, legitimate
              interest, and/or consent.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-394" data-mp="2kw2nwzi22rns">
              Automated Decision-Making
            </h3>

            <p data-id="element-395" data-mp="1s5c2hr2fwsrs">
              We may engage in automated decision-making, including profiling.
            </p>

            <p className="text-sm italic" data-id="element-396" data-mp="2734cy4t4qqz4">
              EU/UK GDPR Lawful Bases: If the EU GDPR or the UK GDPR applies to
              our processing of personal information under this section, our
              lawful bases may include performance of a contract, legitimate
              interest, consent, and/or compliance with legal obligations.
            </p>

            <h2 id="section-4" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-397" data-mp="3dkzvo8on562a">
              4. HOW WE SHARE PERSONAL INFORMATION
            </h2>

            <p data-id="element-398" data-mp="3uksxriwe47b3">
              We share personal information with third parties for a variety of
              business purposes, including to provide the Services, to protect
              us or others, or in connection with a major business transaction
              such as a merger, sale, or asset transfer, as described below.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-399" data-mp="3bt05jqp5aq4f">
              Disclosures to Provide the Services
            </h3>

            <p data-id="element-400" data-mp="3gl1qs24ajr6l">
              We may share any of the personal information we collect with the
              categories of third parties described below.
            </p>

            <p data-id="element-401" data-mp="2o3fj2xts9aqe">
              <strong data-id="element-402" data-mp="2o2xg7icm7y9i">Service Providers.</strong> We may share personal
              information with service providers that assist us with the
              provision of the Services. This may include, but is not limited
              to, service providers that provide us with hosting services,
              customer service, AI or machine learning services, analytics,
              marketing services, IT support, and related services. In addition,
              personal information and chat communications may be shared with
              service providers that help provide our chat features.
            </p>

            <p data-id="element-403" data-mp="hhp6yfhxxr6z">Some of the service providers we may use include:</p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-404" data-mp="dgvj1m4i0ce3">
              <li data-id="element-405" data-mp="dfkh7rum5epm">
                <strong data-id="element-406" data-mp="8ik5p1ezvjr4">Google Analytics.</strong> For more information about
                how Google uses your personal information, please visit Google
                Analytics' Privacy Policy. To learn more about how to opt out of
                Google Analytics' use of your personal information, please click
                here.
              </li>
            </ul>

            <p data-id="element-407" data-mp="1yoqhfua787se">
              <strong data-id="element-408" data-mp="23lqoo8isbgl3">Other Users You Share or Interact With.</strong> The
              Services may allow Fifth Door users to share personal information
              or interact with other users of the Services. When you publish a
              game, other users may see your username and interact with your
              game. When you use the friends feature, your username and public
              profile information may be shared with users who accept your
              friend request, enter your referral code, or click on the referral
              link.
            </p>

            <p data-id="element-409" data-mp="1602tts1z96bo">
              <strong data-id="element-410" data-mp="1ax2zi1ux0729">Third-Party Services You Share or Interact With.</strong>{' '}
              The Services may link to or allow you to interface with, interact
              with, share information with, direct us to share information with,
              access, and/or use a Third-Party Service.
            </p>

            <p data-id="element-411" data-mp="tn7fkstju81d">
              Any personal information shared with a Third-Party Service will be
              subject to the Third-Party Service's privacy policy. We are not
              responsible for the processing of personal information by
              Third-Party Services.
            </p>

            <p data-id="element-412" data-mp="ymbnzh8ng1qn">
              <strong data-id="element-413" data-mp="ymk3zi02jn62">Business Partners.</strong> We may share your personal
              information with business partners we work with to provide you
              with a product or service you have requested. We may also share
              your personal information with business partners with whom we
              jointly offer products or services.
            </p>

            <p data-id="element-414" data-mp="1hdky9sq8uuja">
              Once your personal information is shared with our business
              partner, it will also be subject to our business partner's privacy
              policy. We are not responsible for the processing of personal
              information by our business partners.
            </p>

            <p data-id="element-415" data-mp="1n23611x6jfgt">
              <strong data-id="element-416" data-mp="1n2l7ccyp8jvl">Affiliates.</strong> We may share your personal
              information with our corporate affiliates.
            </p>

            <p data-id="element-417" data-mp="1s2hcifj4uhcq">
              <strong data-id="element-418" data-mp="1w281cdp3mnem">Advertising Partners.</strong> We may share your personal
              information with third-party advertising partners. These
              third-party advertising partners may set Technologies on our
              Services to collect personal information regarding your activities
              and your device (e.g., IP address, cookie identifiers, page(s)
              visited, location, time of day). These advertising partners may
              use this personal information (and similar information collected
              from other services) to tailor and deliver personalized ads to you
              when you visit digital properties within their networks. This
              practice is commonly referred to as "interest-based advertising,"
              "personalized advertising," or "targeted advertising."
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-419" data-mp="33v88t8jhyxep">
              Disclosures to Protect Us or Others
            </h3>

            <p data-id="element-420" data-mp="2tvr4ovjw8rku">
              We may share your personal information and related information
              with external parties if we, in good faith, believe doing so is
              required or appropriate to comply with law enforcement requests,
              national security requests, or other government requests; comply
              with legal process, such as a court order or subpoena; protect
              your, our, or others' rights, property, or safety; enforce our
              policies or contracts; collect amounts owed to us; or assist with
              an investigation or prosecution of suspected or actual
              unauthorized or illegal activity.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-421" data-mp="4eth7opopog1">
              Disclosure in the Event of Merger, Sale, or Other Asset Transfers
            </h3>

            <p data-id="element-422" data-mp="o197yyxcyyn5">
              If we are involved in a merger, acquisition, financing,
              reorganization, bankruptcy, receivership, purchase or sale of
              assets, transition of service to another provider, or other
              similar corporate transaction, your personal information may be
              shared, sold, or transferred as part of such a transaction.
            </p>

            <h2 id="section-5" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-423" data-mp="16tv1vdopgf53">
              5. YOUR PRIVACY CHOICES AND RIGHTS
            </h2>

            <p data-id="element-424" data-mp="11t766epj7a4j">
              <strong data-id="element-425" data-mp="11snqz5r9mzu7">Your Privacy Choices.</strong> The privacy choices you may
              have about your personal information are described below.
            </p>

            <p data-id="element-426" data-mp="3mkpuees8fu8x">
              <strong data-id="element-427" data-mp="3ml93d5zwn8at">Email Communications.</strong> If you receive an unwanted
              email from us, you can use the unsubscribe functionality found at
              the bottom of the email to opt out of receiving future emails.
              Note that you will not be able to opt out of certain
              communications (e.g., communications regarding the Services or
              updates to this Privacy Notice).
            </p>

            <p data-id="element-428" data-mp="29k37ekyk6916">
              <strong data-id="element-429" data-mp="1lw3f3gllmakh">Mobile Devices.</strong> We may send you push
              notifications through our mobile application. You may opt out of
              receiving these push notifications by changing the settings on
              your mobile device. With your consent, we may also collect precise
              location-based information via our mobile application. You may opt
              out of this collection by changing the settings on your mobile
              device. To request deletion of your account, please use the
              standard deletion functionality available via the Services or
              contact us using the information set forth in "Contact Us" below.
            </p>

            <p data-id="element-430" data-mp="3mnecy4nwu7ow">
              <strong data-id="element-431" data-mp="3mmv73mbjb9r8">"Do Not Track."</strong> Do Not Track ("DNT") is a privacy
              preference that users can set in certain web browsers. Please note
              that we do not respond to or honor DNT signals or similar
              mechanisms transmitted by web browsers.
            </p>

            <p data-id="element-432" data-mp="e735n8pora7b">
              <strong data-id="element-433" data-mp="e7kz5xkyrabj">Cookies.</strong> You may stop or restrict the placement
              of Technologies on your device or remove them by adjusting your
              preferences as your browser or device permits. However, if you
              adjust your preferences, the Services may not work properly.
            </p>

            <p data-id="element-434" data-mp="afyye7xl5o7">
              Please note that cookie-based opt-outs are not effective on mobile
              applications. However, you may opt out of certain tracking on some
              mobile applications by following the instructions for Android,
              iOS, and other mobile operating systems.
            </p>

            <p data-id="element-435" data-mp="2ftgvp8ihdqp7">
              The online advertising industry also provides mechanisms that may
              allow you to opt out of receiving targeted ads from organizations
              that participate in self-regulatory programs. To learn more, visit
              the Network Advertising Initiative, the Digital Advertising
              Alliance, and the European Digital Advertising Alliance.
            </p>

            <p data-id="element-436" data-mp="2yjf45pq6xltd">
              Please note you must separately opt out in each browser and on
              each device.
            </p>

            <p data-id="element-437" data-mp="33k2ro1f7nkiu">
              <strong data-id="element-438" data-mp="33hgn8anm9l4u">Your Privacy Rights.</strong> In accordance with
              applicable law, you may have the right to:
            </p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-439" data-mp="1961xvuyipnpm">
              <li data-id="element-440" data-mp="197mppctg6sjs">
                Request Access to or Portability of Your Personal Information;
              </li>
              <li data-id="element-441" data-mp="163f9w20jrwzp">Request Correction of Your Personal Information;</li>
              <li data-id="element-442" data-mp="165rp47ex7t92">Request Deletion of Your Personal Information;</li>
              <li data-id="element-443" data-mp="115vv90zxti78">
                Request Restriction of or Object to Our Processing of Your
                Personal Information; and
              </li>
              <li data-id="element-444" data-mp="1b2ryosazbe4x">
                Withdraw Your Consent to Our Processing of Your Personal
                Information. Please note that your withdrawal will take effect
                only for future processing and will not affect the lawfulness of
                processing before the withdrawal.
              </li>
            </ul>

            <p data-id="element-445" data-mp="1yrb6l6q49owh">
              If you would like to exercise any of these rights, please contact
              us as set forth in "Contact Us" below.
            </p>

            <p data-id="element-446" data-mp="27srdv5lmxawh">
              We will process such requests in accordance with applicable laws.
            </p>

            <p data-id="element-447" data-mp="23rz2a5paitx1">
              If your personal information is subject to the applicable data
              protection laws of the European Economic Area or the United
              Kingdom, you have the right to lodge a complaint with the
              competent supervisory authority if you believe that our processing
              of your personal information violates applicable law.
            </p>

            <h2 id="section-6" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-448" data-mp="2idcy07q3jzcb">
              6. INTERNATIONAL TRANSFERS OF PERSONAL INFORMATION
            </h2>

            <p data-id="element-449" data-mp="1upcxig2zgukj">
              All personal information processed by us may be transferred,
              processed, and stored anywhere in the world, including, but not
              limited to, the United States or other countries, which may have
              data protection laws that are different from the laws where you
              live. These countries may or may not have adequate data protection
              laws as defined by the data protection authority in your country.
            </p>

            <p data-id="element-450" data-mp="2o11ko30m4c1u">
              If we transfer personal information from the European Economic
              Area, Switzerland, and/or the United Kingdom to a country that
              does not provide an adequate level of protection under applicable
              data protection laws, one of the safeguards we may use to support
              such transfer is the EU Standard Contractual Clauses.
            </p>

            <p data-id="element-451" data-mp="24cj0jzugrou0">
              For more information about the safeguards we use for international
              transfers of your personal information, please contact us as set
              forth below.
            </p>

            <h2 id="section-7" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-452" data-mp="1vegtp3o1u1yt">
              7. RETENTION OF PERSONAL INFORMATION
            </h2>

            <p data-id="element-453" data-mp="13z524jgwqmw">
              We store the personal information we collect as described in this
              Privacy Notice for as long as you use the Services, or as long as
              necessary to fulfill the purpose(s) for which it was collected, or
              as long as necessary to pursue our business purposes.
            </p>

            <p data-id="element-454" data-mp="fvhhjsd4c31i">
              To determine the appropriate retention period for personal
              information, we may consider applicable legal requirements; the
              amount, nature, and sensitivity of the personal information;
              certain risk factors; the purposes for which we process your
              personal information; and whether we can achieve those purposes
              through other means.
            </p>

            <h2 id="section-8" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-455" data-mp="13i7jktpgvxm4">
              8. SUPPLEMENTAL NOTICE FOR EU/UK GDPR
            </h2>

            <p data-id="element-456" data-mp="2zmx3zuj8torw">
              This Supplemental Notice for EU/UK GDPR applies only to our
              processing of personal information that is subject to the EU or UK
              General Data Protection Regulation.
            </p>

            <p data-id="element-457" data-mp="38nlgulwwhj37">
              In some cases, providing personal information may be a requirement
              under applicable law, a contractual requirement, or a requirement
              necessary to enter into a contract. If you choose not to provide
              personal information in cases where it is required, we will inform
              you of the consequences at the time of your refusal to provide the
              personal information.
            </p>

            <h2 id="section-9" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-458" data-mp="2268446duswl5">
              9. CHILDREN'S PERSONAL INFORMATION
            </h2>

            <p data-id="element-459" data-mp="hgcj7o1vjczm">
              The Services are not directed to children under 13 (or other age
              as required by local law outside the United States), and we do not
              knowingly collect personal information from children.
            </p>

            <p data-id="element-460" data-mp="8oizxtuyno6c">
              If you are a parent or guardian and believe that your child has
              uploaded personal information to the Services in violation of
              applicable law, you may contact us as described in "Contact Us"
              below.
            </p>

            <h2 id="section-10" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-461" data-mp="mf5uraxlotx5">
              10. CONTACT US
            </h2>

            <p data-id="element-462" data-mp="3c5izu7epksj0">
              Fifth Door is the controller of the personal information we
              process under this Privacy Notice.
            </p>

            <p data-id="element-463" data-mp="7l3mcd9cikxv">
              If you have any questions about our privacy practices or this
              Privacy Notice, or to exercise your rights as detailed in this
              Privacy Notice, please contact us at:{' '}
              <a href="mailto:accounts@fifthdoor.com" className="text-white underline hover:opacity-80" data-id="element-464" data-mp="3ovjumlgf4a8p">
                accounts@fifthdoor.com
              </a>
              .
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-465" data-mp="lgxmo7w201zd" />
    </>;
}